import { render } from "./BannerComp.vue?vue&type=template&id=141f04b9"
import script from "./BannerComp.vue?vue&type=script&lang=js"
export * from "./BannerComp.vue?vue&type=script&lang=js"

import "./BannerComp.vue?vue&type=style&index=0&id=141f04b9&lang=css"

import exportComponent from "D:\\Github\\cj-assets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__